import React, { useCallback, useEffect, useRef, useState } from "react";
import "./DosaChutneyMenu.scss"
import border from "../../assets/images/border.png"
import { useDispatch, useSelector } from "react-redux";
import { fetchAllRestaurantMenuData, getAllData, getAvailableMenuItems, getAvailableMenus } from "../../../../../../../redux/resturantWidgetSlice";
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../../../utilities/helper";
import MenuItem from "../../components/MenuItem/MenuItem";
import arrow from "../../assets/icons/arrow-green.svg"
import { sortByOrderAscending } from "../../helper/helper";
const DosaChutneyMenu = () => {
    const company = useSelector((state) => state.companyData.company);
    const containerRef = useRef(null);
    const contentRef = useRef(null);
    const { menuData: { storage: { mainMenus } }, menuData, defualtSelectedLocation, organizationID, orderCartData } = useSelector((state) => state.resturantData);
    const itemRefs = useRef([]);
    const tabRefs = useRef([]);
    const [data, setData] = useState(null)
    const [itemsData, setItemsData] = useState(data)
    const [isLoading, setIsLoading] = useState(false)
    const [categories, setCategories] = useState([])


    const [selectedItem, setSelectedItem] = useState(sessionStorage.getItem(`scroll`) ? sessionStorage.getItem(`scroll`) : "");
    const dispatch = useDispatch()
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "menu")
    const Components = page?.Components || []
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const fetchMenuData = useCallback(() => {
        const userId = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);

        dispatch(fetchAllRestaurantMenuData({
            CloudLocationID: company?.LocationID,
            OrganizationID: company?.OrganisationID,
            UserID: localStorage.getItem('isLogged') && localStorage.getItem('isLogged') === 'true' ? userId : "",
            Type: "MENU"
        }));

    }, [dispatch, defualtSelectedLocation, organizationID]);


    useEffect(() => {
        setIsLoading(true)
        fetchMenuData();

    }, []);
    useEffect(() => {
        getAllData().then((result) => {
            setData(result);

        });
    }, [menuData]);
    useEffect(() => {
        if (data) {
            const menuDataObject = data
            let filteredCategories = getAvailableMenus(
                menuDataObject.data.Menu,
                menuDataObject.data.Categories
            )
            let filteredItems = getAvailableMenuItems(
                menuDataObject.data.Items,
                filteredCategories
            )
            const updatedData = {
                ...menuDataObject.data,
                Categories: filteredCategories,
                Items: filteredItems
            };
            setCategories(filteredCategories);
            setItemsData(updatedData);
            setIsLoading(false)
        }

    }, [isLoading, data]);
    const getCatgoryItems = (menuEntities) => {
        if (!menuEntities || !Array.isArray(menuEntities) || !itemsData?.Items) return [];
        const menuItemIDs = menuEntities.flatMap(entity => entity.ID);
        const items = itemsData.Items.filter(item => menuItemIDs.includes(item.MenuItemID));

        return items;
    }
    useEffect(() => {
        if (data && selectedItem === "" && categories) {
            if (selectedItem === "") {
                setSelectedItem(categories[0]?.MenuCategoryID
                );
                window.scrollTo({ top: 0, behavior: "smooth" });
            } else {
                const selectedItemPosition = itemRefs.current[selectedItem].getBoundingClientRect().top + window.scrollY - 270;
                window.scrollTo(0, parseInt(selectedItemPosition, 10));
            }
        }

    }, [data, categories])


    useEffect(() => {
        // const container = containerRef.current;
        // const content = contentRef.current;

        // if (!container || !content) return;

        // let scrollLeft = 0;
        // let animationFrame;

        // const clone = content.cloneNode(true);
        // container.appendChild(clone);

        // const animate = () => {
        //     scrollLeft += 0.5;
        //     if (scrollLeft >= content.scrollWidth) {
        //         scrollLeft = 0;// Reset seamlessly
        //     }
        //     container.scrollLeft = scrollLeft;
        //     animationFrame = requestAnimationFrame(animate);
        // };

        // animationFrame = requestAnimationFrame(animate);

        // return () => cancelAnimationFrame(animationFrame);
    }, []);
    const getImagesCarousel = (data) => {
        return (
            <div className="DosaChutneyMenu-ImageCarousel" ref={containerRef}>
                <div className="DosaChutneyMenu-Cont" ref={contentRef}>
                    {data?.map((data, index) => (
                        <img key={index} src={data?.src} alt={`img-${index}`} className="DosaChutneyMenu-Cont-image" />

                    ))}
                </div>
            </div>
        )
    }

    useEffect(() => {
        const handleScroll = () => {

            const scrollPosition = window.scrollY + heightTop;
            let activeId = null;

            Object.entries(itemRefs.current).forEach(([id, item]) => {
                if (item) {
                    const { top, bottom } = item.getBoundingClientRect();
                    const itemTop = top + window.scrollY - heightTop;
                    const itemBottom = bottom + window.scrollY - heightTop;

                    if (itemTop <= scrollPosition && itemBottom >= scrollPosition) {
                        activeId = id;
                    }
                }
            });
            if (activeId) {
                setSelectedItem(activeId);
                tabRefs.current[activeId]?.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "center",
                });
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    const ccategoryRef = useRef(null);
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(true);
    const heightTop = window.innerWidth < 600 ? 310 : 190
    const handleSelect = (id) => {
        if (!itemRefs.current[id]) return;

        setSelectedItem(id);

        const selectedItemPosition = itemRefs.current[id].getBoundingClientRect().top + window.scrollY - 200;
        window.scrollTo({ top: selectedItemPosition, behavior: "smooth" });

        setTimeout(() => {
            tabRefs.current[id]?.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center",
            });
        }, 200);
    };
    useEffect(() => {
        const checkScroll = () => {
            const el = ccategoryRef.current;
            if (!el) return;

            setShowLeftArrow(el.scrollLeft > 10);
            setShowRightArrow(el.scrollWidth > el.clientWidth + el.scrollLeft + 10);
        };

        const el = ccategoryRef.current;
        if (el) el.addEventListener("scroll", checkScroll);
        window.addEventListener("resize", checkScroll);

        checkScroll();

        return () => {
            if (el) el.removeEventListener("scroll", checkScroll);
            window.removeEventListener("resize", checkScroll);
        };
    }, [categories]);

    const getHeroComponent = (component) => {
        switch (component.ID) {
            case "DosaChutneyMenu-Hero-header":
                return <div className="DosaChutneyMenu-Hero-header">
                    {component?.Props?.text}
                </div>
            case "DosaChutneyMenu-Hero-subheader":
                return <div className="DosaChutneyMenu-Hero-subheader">
                    {component?.Props?.text}
                </div>
            default:
                return <div />
        }

    }
    const getHeroContent = (components, heroBackground) => {
        return (
            <div className="DosaChutneyMenu-Hero"
                style={{
                    backgroundImage: `linear-gradient(135deg, rgba(32, 70, 7, 0.59), rgba(19, 44, 2, 0.7)), url(${heroBackground})`
                }}>
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getHeroComponent(component)
                    )
                })}
            </div>
        )
    }
    const getContainerContentComponent = (component) => {
        switch (component.ID) {
            case "DosaChutneyMenu-Container-header-subtext":
                return <div className="DosaChutneyMenu-Container-header-subtext">
                    {component?.Props?.text}
                </div>
            case "DosaChutneyMenu-Container-header-text":
                return <div className="DosaChutneyMenu-Container-header-text">
                    {component?.Props?.text}
                </div>
            case "DosaChutneyMenu-Container-border":
                return <img alt="" src={border}
                    className="DosaChutneyMenu-Container-header-border" />
            case "DosaChutneyMenu-Container-header-content":
                return <div className="DosaChutneyMenu-Container-header-content">
                    {component?.Props?.text}
                </div>
            default:
                return <div />
        }

    }
    const getContainerContent = (components) => {
        return (
            <div className="DosaChutneyMenu-Container-header">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getContainerContentComponent(component)
                    )
                })}
            </div>
        )
    }
    const getMenu = () => {
        return (
            <div>
                {!isLoading ? <>
                    {categories?.length > 0 &&
                        <div className="DosaChutneyMenu-container-menu">
                            {showLeftArrow &&
                                <div
                                    className="arrow-emnu-left"
                                    onClick={() =>
                                        (ccategoryRef.current.scrollLeft -= 150)
                                    }
                                >
                                    <img alt="" src={arrow} />
                                </div>}

                            <div className="DosaChutneyMenu-container-menu-inner"
                                ref={ccategoryRef}>
                                {categories.map((category) => {
                                    return (
                                        <div
                                            className={selectedItem === category?.MenuCategoryID ? "DosaChutneyMenu-container-menu-inner-item-selected" : "DosaChutneyMenu-container-menu-inner-item"}
                                            ref={(el) => (tabRefs.current[category?.MenuCategoryID] = el)}
                                            onClick={() => {
                                                handleSelect(category?.MenuCategoryID)
                                            }}
                                        >{category?.Title?.en}</div>
                                    )
                                })}</div>
                            {showRightArrow && <div
                                className="arrow-emnu-right"
                                onClick={() =>
                                    (ccategoryRef.current.scrollLeft += 150)
                                }
                            >
                                <img alt="" src={arrow} />

                            </div>}
                        </div>}
                    {categories?.map((category) => {
                        return (
                            <MenuItem
                                layout={"layout2"}
                                items={
                                    getCatgoryItems(category.MenuEntities)
                                }
                                showHeader
                                headerText={category?.Title?.en}
                                hideFav={true}
                                limited={false}
                                itemRefs={itemRefs}
                                category={category} />
                        )
                    })}
                </> : <div
                    className="DosaChutneyMenu-loader " />}
            </div>
        )
    }
    const getMenuContentComponent = (component) => {
        switch (component.ID) {
            case "DosaChutneyMenu-Container-header":
                return getContainerContent(component?.Components)
            case "DosaChutneyMenu-Container-menu":
                return getMenu()
            default:
                return <div />
        }

    }
    const getMenuContent = (components) => {
        return (
            <div className="DosaChutneyMenu-Container">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getMenuContentComponent(component)
                    )
                })}
            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "DosaChutneyMenu-Hero":
                return getHeroContent(component.Components, component?.Props?.bgSrc)
            case "DosaChutneyMenu-Container":
                return getMenuContent(component?.Components)
            case "DosaChutneyMenu-Images":
                return getImagesCarousel(component.Data)
            default:
                return <div />
        }

    }
    return (
        <div className="DosaChutneyMenu">
            {sortByOrderAscending(Components).map((component, key) => {
                return (<div key={key}>
                    {getComponents(component)}
                </div>)
            })}
        </div>
    )
}
export default DosaChutneyMenu
